(function () {
    'use strict';

    let module = angular.module('uwAgenda.users');
    module.controller('UserShowInfoModalController', ['$uibModalInstance', '$filter', '$timeout', 'AuthenticationService', 'user', UserShowInfoModalControllerFn]);

    // controller for show information on user in modal
    function UserShowInfoModalControllerFn($uibModalInstance, $filter, $timeout, AuthenticationService, user) {
        let vm = this;
        // contact infos to show ?
        vm.contactInfosToShow = false;

        // user
        vm.user = null;
        // rendered 
        vm.rendered = false;

        activate();

        // activation work
        function activate() {
            vm.user = user;
            // only show active contact infos
            vm.user.contactInfos = $filter('filter')(vm.user.contactInfos, { deleted: false }, true);

            // does user have contact info to show ?
            if (vm.user.detail !== null &&
                (vm.user.detail.street !== null || vm.user.detail.streetNumber !== null || vm.user.detail.zipCode !== null
                    || vm.user.detail.location !== null || vm.user.detail.country !== null)
                || vm.user.contactInfos.length > 0) {
                vm.contactInfosToShow = true;
            } //if

            // after rendering modal -> show map -> important
            let timeouter = $timeout(function () {
                vm.rendered = true;
            }, 0);
        }

        // cancel
        vm.cancel = function () {
            $uibModalInstance.close();
        };
       
    }
})();
